import React from 'react';

import IframeComponent from './iframe.component';

import ModuleWrapper from 'src/components/moduleWrapper';

import SiteContainer from 'src/components/siteContainer/siteContainer';
import { ModuleHeadV2 } from 'src/components/moduleHead/moduleHead.v2';
import BackgroundImageWrapper from 'src/components/backgroundImageWrapper/backgroundImageWrapper';
import { ModuleWrapperV2 } from 'src/components/moduleWrapper/moduleWrapper.v2';
import { getLanguageField } from 'src/utils/language';
import { contrast } from 'src/utils/colors';

import "./iframes.css"

export default function Iframes({ data }) {
  const [activeFrame, setActiveFrame] = React.useState(0);

  const moduleData = {
    minHeight: data.item?.min_height || 550,
    mobileHeight: data.item?.mobile_min_height,
    alignment: data.item.alignment,

    name: data.item?.name,
    anchor: getLanguageField(data.item.translations, data.selectedLanguage, 'anchor'),
    title: getLanguageField(data.item.translations, data.selectedLanguage, 'title'),
    subtitle: getLanguageField(data.item.translations, data.selectedLanguage, 'subtitle'),
    description: getLanguageField(data.item.translations, data.selectedLanguage, 'body', true, true),

    frames: getLanguageField(data.item.translations, data.selectedLanguage, 'iframes'),

    paddings: {
        top: data.item.padding_top,
        bottom: data.item.padding_bottom
    },
    fullWidth: data?.item?.width === "full_screen",
    roundedCorners: data?.item?.width !== "full_screen" && data?.item?.rounded_corners
  };

  const colors = {
    active_color: data.item?.active_tab_text_color?.value,
    active_background: data.item?.active_tab_background_color?.value,
    inactive_color: data.item?.inactive_tab_color?.value,

    title: data.item?.title_color?.value,
    subtitle: data.item?.subtitle_color?.value,
    description: data.item?.body_color?.value,
    // to be removed text: data.item?.text_color?.value || contrast(data.item?.background_color?.value),

    background: data.item?.background_color?.value,
    boxedBackgroundColor: !moduleData.fullWidth && (data.item?.boxed_background_color?.value),
    scrollbar: contrast(data.item?.background_color?.value)
  };

  const showButtons = moduleData.frames.length > 1;
  const noFrames = moduleData.frames.length === 0;

  function getActiveUrl() {
    return moduleData.frames[activeFrame]?.tab_url;
  }

  function getActiveTitle() {
    return moduleData.frames[activeFrame]?.tab_label;
  }


  // no frames, only modulewrapper for anchoring
  if (noFrames) return <ModuleWrapper anchor={moduleData.anchor} name={moduleData.name} className={`relative`} style={{backgroundColor: colors.background}} />

  const height = moduleData.minHeight ? `${moduleData.minHeight}px` : undefined;
  const mobheight = moduleData.mobileHeight ? `${moduleData.mobileHeight}px` : undefined;
  const outterMargin = moduleData.fullWidth ? "" : "mx-auto"
  const innerPaddings = moduleData.fullWidth ? "" : "p-4 sm:px-6 xl:px-0"

  const style = {
    '--hyperlink-text-color': data.item?.hyperlink_text_color?.value,
    '--hyperlink-hover-color': data.item?.hyperlink_hover_color?.value,
    '--scrollbg': colors.scrollbar,
    '--desktop-height': height,
    '--mobile-height': mobheight,
    color: colors.text,
  }

  return (
    <BackgroundImageWrapper backgroundColor={colors.background}>
      <SiteContainer fullwidth={moduleData.fullWidth}>
        <ModuleWrapperV2
          anchor={moduleData.anchor}
          name={moduleData.name}
          roundedCorners={moduleData.roundedCorners}
          className={`relative ${innerPaddings} ${outterMargin} flex flex-col gap-8 w-full`}
          style={style}
          paddings={moduleData.paddings}
          backgroundColor={colors.boxedBackgroundColor}
          isFullWidth={moduleData.fullWidth}
        >
        {/* Module head */}
          <ModuleHeadV2
            title={moduleData.title}
            subtitle={moduleData.subtitle}
            description={moduleData.description}
            color_title={colors.title}
            color_subtitle={colors.subtitle}
            color_description={colors.description}
            alignment={moduleData.alignment}
            align_lists
          />

          {/* Active tab selector */}
          {showButtons ? <div className={"relative flex mb-4"}>
              <div className="inline-flex overflow-x-auto scrollbarx">
                  {moduleData.frames.map((frame, index) => {
                      const onSpaceSelect = (e) => { if (e.nativeEvent.code === "Space" || e.nativeEvent.code === "Enter") setActiveFrame(index); }
                      if (index === activeFrame) return <span role="button" aria-label={frame.tab_label} tabIndex={-1} onKeyDown={onSpaceSelect} onClick={() => setActiveFrame(index)} key={index} style={{ backgroundColor: colors.active_background, color: colors.active_color }} className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base rounded-md buttonText font-medium mx-3 rounded-md shadow cursor-pointer">{frame.tab_label}</span>
                      return <span role="button" aria-label={frame.tab_label} tabIndex={-1} onKeyDown={onSpaceSelect}  onClick={() => setActiveFrame(index)} key={index} style={{color: colors.inactive_color}} className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base rounded-md buttonText font-medium mx-3 rounded-md cursor-pointer">{frame.tab_label}</span>
                  })}
              </div>
          </div> : null }

          {/* iframe */}
          <div className={`relative component-iframe-wrapper`}>
            <IframeComponent
              title={getActiveTitle()}
              height={height}
              src={getActiveUrl()}
            />
          </div>
        </ModuleWrapperV2>
      </SiteContainer>
    </BackgroundImageWrapper>
  );
};
